import React, { useEffect } from 'react';
import { useLocation, useNavigate, Outlet } from 'react-router';

import { useAppSelector } from '@/store';
import { authStore } from '@/store/auth';
import { pages } from '@/settings/pages';
import { auth } from '@/constants';

type Props = {
  memberAccessible?: boolean;
};

export const PrivateRoute: React.FC<Props> = ({ memberAccessible = false }) => {
  const isLoggedIn = useAppSelector(authStore.selectors.isLoggedInSelector);
  const hasSession = useAppSelector(authStore.selectors.hasSessionSelector);
  const isMember = useAppSelector(authStore.selectors.isMemberSelector);
  const gloplaId = useAppSelector(authStore.selectors.gloplaIdSelector);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // 未ログインまたは組織の情報がReduxに格納されなかった場合はoidcフローを開始
    if (!isLoggedIn || !gloplaId) {
      window.location.href = auth.Url.signinUri;
    }

    if (!hasSession) {
      return navigate(pages.signin.index, { replace: true });
    }

    const from = location.state?.from ?? { pathname: pages.top };

    // 組織選択あるけど権限での制限があるときはリダイレクト
    if (!memberAccessible && isMember) {
      return navigate(pages.top, { replace: true });
    }

    // 所属組織が1つの時に遷移元があればリダイレクト
    if (from.pathname !== pages.top) {
      return navigate(from.pathname, { replace: true });
    }
  }, [
    isLoggedIn,
    hasSession,
    isMember,
    location,
    memberAccessible,
    navigate,
    gloplaId,
  ]);

  return <Outlet />;
};
